import { render } from "./mode_user.vue?vue&type=template&id=5fc67fcd&ts=true"
import script from "./mode_user.vue?vue&type=script&lang=ts"
export * from "./mode_user.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/mode_user.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fc67fcd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fc67fcd', __exports__)) {
    api.reload('5fc67fcd', __exports__)
  }
  
  module.hot.accept("./mode_user.vue?vue&type=template&id=5fc67fcd&ts=true", () => {
    api.rerender('5fc67fcd', render)
  })

}


export default __exports__